module.exports = __webpack_public_path__ + "img/SL-M-260-310.d145f3ee.svg";